import { render, staticRenderFns } from "./InvoiceCards.vue?vue&type=template&id=6966571c"
import script from "./InvoiceCards.vue?vue&type=script&lang=js"
export * from "./InvoiceCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports